import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {
  @Input() pdfSrc = "../../../assets/pdf/historia_informatica.pdf";
  @Output() PdfLoad = new EventEmitter()
  src = ""
  constructor() { }

  ngOnInit() {}


  ngOnChanges(): void {
    // setTimeout(() => {
    //   this.Imprimir()
    // }, 5000);
      this.src = this.pdfSrc
  
  }

  Imprimir(){
    let a = open(this.src, "_blank")
  }

  PdfCarcado(ev){
    this.PdfLoad.emit(ev)
  }
}
